import React, { Component  } from "react"
import {Table, Row, Pagination, Tooltip ,Select,Input,Tabs,message,Button,Icon} from "antd"
// import config from "app/config"
import CnvRead from './CnvRead'
import { observer, inject } from 'mobx-react'
import cx from 'classnames'
import { PREPARE_RUN, RUNNING } from 'app/utils/const'
import { observable } from "mobx"
import "./Index.scss"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"

const Option = Select.Option
@inject('auth') @observer
export default class ReportDetail extends Component {
  
  @observable dumplicateCnv = ''
  constructor(props) {
 
    super(props)
    this.state = {
      isOpenImg1: false,
      isOpenImg2: false,
      activeReportIndex: 0,
      currentPage: 1,
      reportListArr: [],
       cnvReadShowed:false,
       gene_annos:[],
      exportModalShowed: false,
      syncBtnLoading: false,
      grade:[
        ['1A','1B'],
        [
          '2A'	,'2B',	'2C-1',	'2C-2',	'2D-1'	,'2D-2'	,'2D-3'	,'2D-4',	'2E-PVS1',
          '2E-PVS1_Moderate',	'2E-PVS1_Strong',	'2E-PVS1_Supporting','2F','2G','2H'
        ],
        ['3A'	,'3B',	'3C'],
        ['4A'	,'4B',	'4C',	'4D',	'4E'	,'4F'	,'4G'	,'4H',	'4I',	'4J',	'4K',	'4L','4M',	'4N',	'4O'],
        ['5A'	,'5B',	'5C',	'5D',	'5E'	,'5F'	,'5G'	,'5H'],
      ],
     
      gradeOriginal: [],
    //初始选中
      dataSource : []
    }
  }
  // shouldComponentUpdate(nextProps, nextState) {
  //   if (this.props.dataSource !== nextProps.dataSource) {   //判断dataSource是否改变
  //     return true
  //   }
  //   if (this.state.dataSource !== nextState.dataSource) {   //判断dataSource是否改变
  //     return true
  //   }
  //   return false    //如果都不改变，则不重新渲染
  // }

  onCloseRequest() {
    this.state = {
      isOpenImg1: false,
      isOpenImg2: false
    }
  }

  showModal = (field) => {
    this.setState({
      [field]: true
    }, () => {
      // console.log('查看:', this.state.cnvReadShowed)
      this.forceUpdate() // 强制更新组件
    })
  }

  closeModal = (field) => {
    this.setState({
      [field]: false
    }, () => {
      // console.log('关闭:', this.state.cnvReadShowed)
      this.forceUpdate()// 强制更新组件
    })
   
  }

  isEmptyObj = (obj) => {
   
    return Object.keys(obj).length === 0
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.index !== this.props.index) {
      this.initNav(nextProps.index)
    }
  }

  componentWillMount() {
    this.initNav(this.props.index)
  }

  componentDidMount() {
    const { index, data} = this.props
    // if (userInfo.roleType !== 'research') {
     
      const { getPgscnv,getPgscnvGuide } = this.props.store
      const reportId = data.reportList[index] && data.reportList[index].reportId
      if (reportId) getPgscnv(reportId)
      getPgscnvGuide()
      setTimeout(() => {
        const gradeOriginal=[...this.props.store.cnvGuide]
        const dataSource=[...this.props.store.innerResult]
        this.setState({
          dataSource:dataSource,
          gradeOriginal:gradeOriginal
        }) 
      }, 500)
     
    // }
  }

  initNav = (index) => {
    this.setState({
      activeReportIndex: index,
      currentPage: Math.floor(index / 10) + 1
    })
  }

  changeReport = (index, record) => {
   
    this.setState({
      dataSource:[],
      gradeOriginal:[]
    }) 
  
    const { getPgscnv,getPgscnvGuide } = this.props.store
   
      getPgscnv(record.reportId)
      getPgscnvGuide()
      setTimeout(() => {
        const gradeOriginal=[...this.props.store.cnvGuide]
        const dataSource=[...this.props.store.innerResult]
        this.setState({
          dataSource:dataSource,
          gradeOriginal:gradeOriginal
        }) 
      }, 1000)
    
    // this.refs.content.scrollTop = 0
    this.setState({
      activeReportIndex: index
    })
    // this.props.dataSwitch(index, record)
  }

  changePage = (e) => {
    let activeReportIndex = (e - 1) * 10
    let record = this.props.reportList[activeReportIndex]
    this.renderReportList(e)
    this.setState({
      currentPage: e,
      activeReportIndex
    })
    this.changeReport(activeReportIndex, record)
  }

  renderSampleName = (reportList, currenNum) => {
    const { hospitalSampleName, sampleName } = reportList[currenNum]
    var sample=''
    if(hospitalSampleName){
       sample = hospitalSampleName +'  ('+ sampleName+')'
    }else{
       sample = sampleName
    }
    if (sample && sample.length > 23) {
      return (
        <Tooltip placement="left" title={sample}>
          {sample.slice(0, 23) + '...'}
        </Tooltip>
      )
    }
    return sample
  }
//添加下拉框
  addAllReportResCnv=(tabIndex,index,Snum)=>{//s4-s5
    // console.log('table表格行对应的下标：'+tabIndex,'需要添加list的下标：'+index,'要添加的是:',Snum)
    const newdataSource=[...this.state.dataSource]
    const  addData={
      info: '',
      info_ch: "--",
      score: "0",
      sec: " "
    }
    newdataSource[tabIndex][Snum].push(addData)
    // console.log('新的list：',newdataSource)
    this.setState({ dataSource:newdataSource })
  }
  //删除下拉框
  delAllReportResEle=(tabIndex,index,Snum)=>{
    
    // console.log('table表格行对应的下标：'+tabIndex,'需要删除list的下标：'+index,'要删除的是:',Snum)
    const newdataSource= [...this.state.dataSource]
    if(newdataSource[tabIndex][Snum].length===1){
      message.error("最少保留一条")
      return false
    }
    newdataSource[tabIndex][Snum].splice(index, 1)
    newdataSource['time']=Date.now()
  //   var that=this
  //   message.success('删除成功')
  // //   that.setState({
  // //     dataSource:[] 
  // //  })
  //   // setTimeout(function(){
  //     that.setState({
  //        dataSource:newdataSource 
  //     })
  //   // },500)

      this.setState({
        dataSource:newdataSource 
      }, () => {
        this.forceUpdate() // 强制更新组件
      })
   
  }
//失去焦点2
inputOnBlur2=(updValues,tabIndex,Snum,index,type)=>{
  updValues=updValues.target.value
  //  console.log('value值',updValues,'table表格行对应的下标：'+tabIndex,'s4-s5需要修改的list下标：'+index,'要修改的是:',Snum)
   const newdataSource=this.state.dataSource
    
   if(Snum==='s1'||Snum==='s2'||Snum==='s3'){
     //先赋值
     newdataSource[tabIndex][Snum][0].info_ch=updValues
   }else{//s4-s5
     //先赋值
     newdataSource[tabIndex][Snum][index].info_ch=updValues
   }
  //  console.log(newdataSource)
   this.setState({ dataSource:newdataSource })
}

  //失去焦点

  inputOnBlur=(updValues,tabIndex,Snum,index,type)=>{
    // console.log('value值',updValues,'table表格行对应的下标：'+tabIndex,'s4-s5需要修改的list下标：'+index,'要删除的是:',Snum)
    if(type!==2){
        updValues=updValues.target.value
    }

    const newdataSource=[...this.state.dataSource]
    const curRow=newdataSource[tabIndex]
    // console.log(curRow)
    if(Snum==='s1'||Snum==='s2'||Snum==='s3'){
        curRow[Snum][0].score = updValues
    }else{
        curRow[Snum][index].score = updValues
    }

    let num_s1s3=0, num_s4s5=0
    num_s1s3=Number(curRow['s1'][0].score)+Number(curRow['s2'][0].score)+Number(curRow['s3'][0].score)
    // // 计算 s1-s3 列的总和
    // for(let i=0; i<newdataSource.length; i++){
    //     for(let j=0; j<newdataSource[i]['s1'].length; j++){
    //         console.log(toNum(newdataSource[i]['s1'][j].score))
    //         num_s1s3 += toNum(newdataSource[i]['s1'][j].score)
    //     }
    //     for(let j=0; j<newdataSource[i]['s2'].length; j++){
    //       console.log(toNum(newdataSource[i]['s2'][j].score))

    //         num_s1s3 += toNum(newdataSource[i]['s2'][j].score)
    //     }
    //     for(let j=0; j<newdataSource[i]['s3'].length; j++){
    //       console.log(toNum(newdataSource[i]['s3'][j].score))

    //         num_s1s3 += toNum(newdataSource[i]['s3'][j].score)
    //     }
    // }

    // 计算 s4 和 s5 列的总和
    for(let i=0; i<curRow['s4'].length; i++){
        num_s4s5 += toNum(curRow['s4'][i].score)
    }
    for(let i=0; i<curRow['s5'].length; i++){
        num_s4s5 += toNum(curRow['s5'][i].score)
    }

      // console.log(num_s1s3,num_s4s5)
    curRow.score = (num_s1s3+num_s4s5).toFixed(2)

    if(curRow.score>=0.99){
        curRow.class='Pathogenic'
    }else if(curRow.score<=-0.99){
        curRow.class='Benign'
    }else if(curRow.score>=0.9&&curRow.score<=0.98){
        curRow.class='LikelyPathgenic'
    }else if(curRow.score>=-0.89&&curRow.score<=0.89){
        curRow.class='Variants of Uncertain Significance'
    }else if(curRow.score>=-0.98&&curRow.score<=0.9){
        curRow.class='LikelyBenign'
    }

    this.setState({ dataSource:newdataSource })

    function toNum(str){
        return Number(str)
    }
}

  //保存
  conserveSubmit=()=>{
     const { index, data} = this.props
    const reportId = data.reportList[index] && data.reportList[index].reportId
    const { conserveCnvGuide } = this.props.store
    const newdataSource=this.state.dataSource
    // console.log(newdataSource)
    conserveCnvGuide(newdataSource, reportId)
    .then(
      res => {
        message.success("保存成功")
      
      },
      err => {
        message.error(err.message)
      }
    )
    
  }
   
  //获取数据
  renderReportList = (pageNumber) => {
    let { reportList } = this.props.data
    const { userInfo: { id } } = this.props.auth
    let reportListArr = []
    let endNum = pageNumber * 10

    if (endNum > reportList.length) {
      endNum = reportList.length
    }
    //文件名列表
    for (let currenNum = (pageNumber - 1) * 10; currenNum < endNum; currenNum++) {
      const { state, reportState, stage } = reportList[currenNum]
      const liClass = cx({
        'report cursor-p': true,
        'active': this.state.activeReportIndex === currenNum,
      })

      const sxClass = cx({
        'report cursor-p': true,
        'active3': (this.state.activeReportIndex === currenNum && reportState === '3'),
        'active2': (this.state.activeReportIndex === currenNum && reportState === '2'),
        'active1': (this.state.activeReportIndex === currenNum && reportState === '1'),
        'hover3': reportState === '3',
        'hover2': reportState === '2',
        'hover1': reportState === '1',
      })

      const angleClass = cx({
        "angle-top": true,
        "angle3": reportState === '3',
        "angle2": reportState === '2',
        "angle1": reportState === '1'
      })

      if (state !== PREPARE_RUN && state !== RUNNING) {
        reportListArr.push(
          <li
            key={currenNum}
            onClick={() => {
                this.changeReport(currenNum, reportList[currenNum])
            }}
            className={(id === '1007'||id === '179')? sxClass : liClass}
          >
            {this.renderSampleName(reportList, currenNum)}
            {
              (stage === 1 &&( id === '1007'||id === '179') ) && (
                <span style={{ marginLeft: 5 }}>✰</span>
              )
            }
            {(id === '1007'||id === '179' ) && (
              <span className={angleClass}></span>
            )}
          </li>
        )
      }
    }
    return reportListArr
  }

selectChange= (checkedValues,tabIndex,Snum,index) => {
  // console.log('表格行对应的下标：'+tabIndex,'要修改的是'+Snum,'要修改的text下标：'+index,'修改selected选项：'+checkedValues,'')
  
   var gradeOriginal=this.state.gradeOriginal
   var newdataSource=this.state.dataSource
   var newSnum=[...newdataSource[tabIndex][Snum]]
  //  console.log(newdataSource)
  //  console.log(newSnum)
    //s1-s3
    if(Snum==='s1'||Snum==='s2'||Snum==='s3'){
      for(let i=0;i<gradeOriginal.length;i++ ){
        if(gradeOriginal[i].name===checkedValues){
          newSnum[0].sec=gradeOriginal[i].name
          newSnum[0].info_ch=gradeOriginal[i].description
          newSnum[0].score=gradeOriginal[i].softwareDefaultScore
        }
      }
      var updValues=newSnum[0].score
    }else{//s4-s5
      for(let i=0;i<gradeOriginal.length;i++ ){
        if(gradeOriginal[i].name===checkedValues){
          newSnum[index].sec=gradeOriginal[i].name
          newSnum[index].info_ch=gradeOriginal[i].description
          newSnum[index].score=gradeOriginal[i].softwareDefaultScore
        }
      }
      // var updValues=newSnum[index].score
    }

    // console.log('newdataSource------',newdataSource)
    this.setState({ dataSource:newdataSource })
    // console.log(updValues)
    //重新计算Score的值
    this.inputOnBlur(updValues,tabIndex,Snum,index,2)
}
//查看
preview = (index) => {
  this.showModal('cnvReadShowed')
  const  gene_annos =index.gene_annos
  this.setState({ gene_annos:gene_annos })
}

render() {
    const {
      currentPage,
      grade,
      cnvReadShowed,
      gene_annos,
      dataSource
    } = this.state
   
    let {
      data = {},
      detailData,
    } = this.props
    const  dataSource2 =[...this.props.store.annResult]
    this.dumplicateCnv = detailData && detailData.resultCNVDumplicate
    let columns = []
    
    // console.log('dataSource------390-------',dataSource)

    if (data.reportList === undefined) {
      data.reportList = []
    } else {
        columns = [
        {
          title: 'CNV',
          dataIndex: 'cnv_name',
          // fixed: 'left',
          key: 'cnv_name',
          render: (record) => (
              <a>{record}</a>
          )
        }, 
        {
          title: 'ISCN',
          dataIndex: 'iscn',
          // fixed: 'left',
          key: 'iscn',
          render: (text) => {
            return (
              <MaterialTip
                overlayClassName="ellipsis-tip"
                title={text}
              >
                <div className="sample-name ellipsis" >
                    {!text?'-':(text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50))}
                </div>
              </MaterialTip>
            )
          }
        },
        {
          title: 'Class',
          dataIndex: 'class',
          // fixed: 'left',
          key: 'class',
          render: (record) => (
              <a>{record}</a>
          )
        },
        {
            title: 'Score',
            dataIndex: 'score',
            // fixed: 'left',
            key: 'Score',
            render: (record) => (
                <a>{record}</a>
            )
        },
        {
          title: 'S1-S5',
          colSpan: 5,
          key: 'S1-S5',
          render: (text, record,tabIndex) => (
            <span>
            </span>
          )
        }
      ]
    }
    const columns2 = [
      { title: 'iscn', dataIndex: 'iscn', key: '7',width:100 ,fixed: 'left',},
      { title: 'length(Mbp)', dataIndex: 'length(Mbp)', key: '6' ,width:50,
        render: (text) => {
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                  {!text?'-':(text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50))}
              </div>
            </MaterialTip>
          )
        },
        fixed: 'left',
      },
      { title: 'coding_genes_num', dataIndex: 'coding_genes_num', key: '9',width:50,fixed: 'left',},
      { title: 'elements_num', dataIndex: 'elements_num', key: '11',width:50 ,fixed: 'left',},
      { title: 'genes_interrupt', dataIndex: 'genes_interrupt', key: '12',width:50,fixed: 'left',},
      { title: 'chrom', dataIndex: 'chrom', key: '1',width:50,},
      { title: 'start', dataIndex: 'start', key: '2',width:50 },
      { title: 'end', dataIndex: 'end', key: '3' ,width:50},
      { title: 'name', dataIndex: 'name', key: '4' ,width:50},
      { title: 'type', dataIndex: 'type', key: '5' ,width:50},
      { title: 'symbols', dataIndex: 'symbols', key: '8' ,width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                    {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
     
      { title: 'genes_num', dataIndex: 'genes_num', key: '10',width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                  {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: 'clingen_hi_pathog_region', dataIndex: 'clingen_hi_pathog_region', key: '13' ,width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                  {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: 'clingen_hi_benign_region', dataIndex: 'clingen_hi_benign_region', key: '14',width:50 ,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                  {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: 'clingen_ts_pathog_region', dataIndex: 'clingen_ts_pathog_region', key: '15',width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                  {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      
      { title: 'clingen_hi_pathog_gene', dataIndex: 'clingen_hi_pathog_gene', key: '16',width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                  {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: 'clingen_hi_benign_gene', dataIndex: 'clingen_hi_benign_gene', key: '17',width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                    {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: 'clingen_ts_pathog_gene', dataIndex: 'clingen_ts_pathog_gene', key: '18',width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                    {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: 'clingen_ts_benign_gene', dataIndex: 'clingen_ts_benign_gene', key: '19',width:50 ,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                    {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: 'decipher_hi_index', dataIndex: 'decipher_hi_index', key: '20',width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                    {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },

      { title: 'gnomad_pli_oe', dataIndex: 'gnomad_pli_oe', key: '21',width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                    {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: 'clingen_recurrent_cnv', dataIndex: 'clingen_recurrent_cnv', key: '22' ,width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                  {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: 'decipher_syndrome', dataIndex: 'decipher_syndrome', key: '23',width:50 ,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                  {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: 'panel_app_cnv', dataIndex: 'panel_app_cnv', key: '24',width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                  {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: 'jabrehoo_1', dataIndex: 'jabrehoo_1', key: '25',width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                  {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },

      { title: 'segmental_duplication', dataIndex: 'segmental_duplication', key: '26' ,width:50,
        render: (text) => {
          
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                    {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: 'encode_black_list', dataIndex: 'encode_black_list', key: '27',width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                  {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: 'dgv_gold', dataIndex: 'dgv_gold', key: '28' ,width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                  {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: 'gnomad_sv', dataIndex: 'gnomad_sv', key: '29',width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                  {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: 'clinvar_snp', dataIndex: 'clinvar_snp', key: '30',width:50,
        render: (text) => {
            
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis" >
                  {!text?'-':text.length>50?(text.substring(0, 50)+'...'):text.substring(0, 50)}
              </div>
            </MaterialTip>
          )
        }
      },
      { title: '操作', dataIndex: '', key: '31',fixed: 'right',width:50,
        render: (text,index) => {
          return (
              <a
                target="_blank"
                onClick={()=>this.preview(index)}
              >
                {/* <Icon type="file-text" /> */}
                查看
              </a>
          )
        }
      },
    ]
      
    const { TabPane } = Tabs
    return (
      <Row type="flex" className="pgs-report-detail">
        <div ref="content" className="content">
        
          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">详情</h3>
           
            <Tabs defaultActiveKey="1">
              <TabPane tab={<span>CNV解读</span>} key="1">
                <div className="components-table-demo-nested">
                  <div className="header-row">
                    {columns.map((column) => (
                      <div key={column.key} className="cell header-cell">{column.title}</div>
                    ))}
                  </div>
                  {dataSource.length > 0 ?
                    dataSource.map((record, tabIndex) => (
                      <div key={record + '-' + tabIndex} className="data-row">
                        {columns.map((column,index) => {
                            if (column.key !== 'S1-S5') {
                              const renderedCell = column.render(record[column.dataIndex])
                              return (
                                <div key={index} className="cell data-cell">
                                  {renderedCell}
                                </div>
                              )
                            }else{
                              // console.log(record.s1 )
                              return(
                                <div key={index} className="cell data-cell cell2">

                                  {record && record.s1 ? (
                                    <div className='Smany'>
                                        <span className='SmanyLef'> S1:</span>
                                        <Select 
                                            className="sNumSelect "
                                            placeholder="评级" 
                                            defaultValue={record.s1[0].sec?record.s1[0].sec:''}
                                            onChange={
                                              (checkedValues) => {this.selectChange(checkedValues,tabIndex ,'s1')}
                                            } 
                                            disabled
                                            allowClear
                                        >
                                          {grade[0].map((item) => (
                                                <Option key={item}>{item}</Option> 
                                            ))}
                                        </Select>
                                        <Input className="sNumInp " disabled placeholder="评分" style={{ width: 80 }}
                                            defaultValue={record.s1[0].score}
                                            key={'S1'+index+ Math.random().toString(36).substring(2, 8)}
                                            onBlur={(updValues) =>this.inputOnBlur(updValues,tabIndex,'s1')}
                                        />
                                        <textarea className="sNumTxt "  placeholder="证据" rows="3" draggable="false"
                                          defaultValue={record.s1[0].info_ch}
                                          key={'S1'+index+ Math.random().toString(36).substring(2, 8)}
                                          onBlur={(updValues) =>this.inputOnBlur2(updValues,tabIndex,'s1')}
                                          disabled
                                        ></textarea>
                                    </div>):null
                                  }
                                  {record && record.s2 ? (
                                    <div className='Smany'>
                                        <span className='SmanyLef'> S2:</span>
                                        <Select 
                                            className="sNumSelect "
                                            placeholder="评级" 
                                            defaultValue={record.s2[0].sec?record.s2[0].sec:''}
                                            onChange={
                                              (checkedValues) => {this.selectChange(checkedValues,tabIndex ,'s2')}
                                            } 
                                            allowClear
                                            disabled
                                        >
                                          {grade[1].map((item) => (
                                                <Option key={item}>{item}</Option> 
                                            ))}
                                        </Select>
                                        <Input className="sNumInp " placeholder="评分" style={{ width: 80 }}
                                            defaultValue={record.s2[0].score}
                                           key={'S2'+index+ Math.random().toString(36).substring(2, 8)}
                                            onBlur={(updValues) =>this.inputOnBlur(updValues,tabIndex,'s2')}
                                            disabled
                                        />
                                        <textarea className="sNumTxt " placeholder="证据"  rows="3" draggable="false"
                                          defaultValue={record.s2[0].info_ch}
                                         key={'S2'+index+ Math.random().toString(36).substring(2, 8)}
                                          onBlur={(updValues) =>this.inputOnBlur2(updValues,tabIndex,'s2')}
                                          disabled
                                        ></textarea>
                                    </div>):null
                                  }
                                  {record && record.s3 ? (
                                    <div className='Smany' >
                                          <span className='SmanyLef'> S3:</span>
                                        <Select 
                                            className="sNumSelect "
                                            placeholder="评级" 
                                            defaultValue={record.s3[0].sec?record.s3[0].sec:''}
                                            onChange={
                                              (checkedValues) => {this.selectChange(checkedValues,tabIndex ,'s3')}
                                            } 
                                            allowClear
                                            disabled
                                        >
                                          {grade[2].map((item) => (
                                                <Option key={item}>{item}</Option> 
                                            ))}
                                        </Select>
                                        <Input className="sNumInp " placeholder="评分" style={{ width: 80 }}
                                            defaultValue={record.s3[0].score}
                                             key={'S3'+index+ Math.random().toString(36).substring(2, 8)}
                                            onBlur={(updValues) =>this.inputOnBlur(updValues,tabIndex,'s3')}
                                            disabled
                                        />
                                        <textarea className="sNumTxt " placeholder="证据" rows="3" draggable="false"
                                          defaultValue={record.s3[0].info_ch}
                                           key={'S3'+index+ Math.random().toString(36).substring(2, 8)}
                                          onBlur={(updValues) =>this.inputOnBlur2(updValues,tabIndex,'s3')}
                                          disabled
                                        ></textarea>
                                    </div>):null
                                  }
                                  {record &&record.s4 ? (
                                    <div className='Smany'>
                                          <span className='SmanyLef'> S4:</span>
                                          <div  className='SmanyRig'>
                                            {(record.s4).map((item,s4index) => (
                                              <div key={item+'-'+s4index} >
                                                      <Select 
                                                          className="sNumSelect"
                                                          placeholder="评级" 
                                                          defaultValue={item.sec?item.sec: ''}
                                                          key={s4index+ Math.random().toString(36).substring(2, 8)}
                                                          onChange={
                                                            (checkedValues) => 
                                                            {this.selectChange(checkedValues,tabIndex,'s4' ,s4index)}
                                                          } 
                                                          allowClear
                                                          disabled
                                                      >
                                                        {grade[3].map((item2) => (
                                                              <Option key={item2}>{item2}</Option> 
                                                          ))}
                                                      </Select>
                                                      <Input className="sNumInp" placeholder="评分" 
                                                        defaultValue={item.score?item.score:'0'}
                                                        key={s4index+ Math.random().toString(36).substring(2, 8)}
                                                        onBlur={(updValues) => 
                                                          this.inputOnBlur(updValues, tabIndex, 's4', s4index)}
                                                          disabled
                                                        />
                                                      <textarea className="sNumTxt" placeholder="证据"  
                                                        rows="3" draggable="false"
                                                        defaultValue={item.info_ch?item.info_ch:'--'}
                                                        key={s4index+ Math.random().toString(36).substring(2, 8)}
                                                        onBlur={(updValues) => 
                                                          this.inputOnBlur2(updValues, tabIndex, 's4', s4index)}
                                                          disabled
                                                      ></textarea>
                                                      {/* <span>
                                                          {s4index !== 0 && 
                                                            <Icon className="minus-all-icon" type="minus-circle"
                                                              onClick={() => 
                                                                this.delAllReportResEle(tabIndex, s4index, 's4')
                                                              }
                                                            /> 
                                                          }
                                                          {s4index === 0 && 
                                                            <Icon className="add-all-icon" type="plus-circle" 
                                                              onClick={() => 
                                                                this.addAllReportResCnv(tabIndex, s4index, 's4')
                                                              }
                                                            />
                                                          }
                                                      </span> */}
                                              </div>
                                            ))}
                                            </div>
                                      </div>):null
                                  }
                                  {record &&record.s5 ? (
                                    <div className='Smany'>
                                          <div  className='SmanyLef'> S5:</div>
                                          <div  className='SmanyRig'>
                                            {(record.s5).map((item,s5index) => (
                                              <div key={item+'-'+s5index}  >
                                                      <Select 
                                                          className="sNumSelect"
                                                          placeholder="评级" 
                                                          defaultValue={item.sec?item.sec: ''}
                                                          key={s5index+ Math.random().toString(36).substring(2, 8)}
                                                          onChange={
                                                            (checkedValues) => 
                                                            {this.selectChange(checkedValues,tabIndex,'s5' ,s5index)}
                                                          } 
                                                          allowClear
                                                          disabled
                                                      >
                                                        {grade[3].map((item2) => (
                                                              <Option key={item2}>{item2}</Option> 
                                                          ))}
                                                      </Select>
                                                      <Input className="sNumInp" placeholder="评分" 
                                                        defaultValue={item.score?item.score:'0'}
                                                        key={s5index+ Math.random().toString(36).substring(2, 8)}
                                                        onBlur={(updValues) => 
                                                          this.inputOnBlur(updValues, tabIndex, 's5', s5index)}
                                                          disabled
                                                        />
                                                      <textarea className="sNumTxt" placeholder="证据"  
                                                       rows="3" draggable="false"
                                                        defaultValue={item.info_ch?item.info_ch:'--'}
                                                        key={s5index+ Math.random().toString(36).substring(2, 8)}
                                                        onBlur={(updValues) => 
                                                          this.inputOnBlur2(updValues, tabIndex, 's5', s5index)}
                                                          disabled
                                                      ></textarea>
                                                      {/* <span>
                                                          {s5index !== 0 && 
                                                            <Icon className="minus-all-icon" type="minus-circle"
                                                              onClick={() => 
                                                                this.delAllReportResEle(tabIndex, s5index, 's5')
                                                              }
                                                            /> 
                                                          }
                                                          {s5index === 0 && 
                                                            <Icon className="add-all-icon" type="plus-circle" 
                                                              onClick={() => 
                                                                this.addAllReportResCnv(tabIndex, s5index, 's5')
                                                              }
                                                            />
                                                          }
                                                      </span> */}
                                              </div>
                                            ))}
                                          </div>
                                      </div>):null
                                  }

                                </div>
                              )
                            }
                        })}
                      </div>
                    )):
                    <div className="data-row data-row-no">
                      <span>暂无数据</span>
                    </div>
                  }
                </div>

              </TabPane>
              <TabPane tab={<span>CNV注释</span>} key="2">
                  <Table
                    className="components-table-demo-nested table-in"
                    columns={columns2}
                    dataSource={dataSource2}
                    scroll={{ x: 1550 }}
                    pagination={false}
                    rowKey={(record, index) => record+'-'+index}
                  />
              </TabPane>
            </Tabs>

            <div className='btn' >
              {/* <Button type="primary" onClick={() => this.conserveSubmit()} >保存结果</Button> */}
              {/* <Button type="primary" >推送报告至Lims</Button> */}
             
            </div>
          </div>
         
        </div> 

        {/* 右侧文件列表 */}
        <div className="reportNav">
            <div className="title">本组数据</div>
            <ul className="reports">
              {this.renderReportList(currentPage)}
            </ul>
            <Pagination
              className="pagination"
              size="small"
              pageSize={10}
              total={
                data.reportList.filter(item =>
                  item.state !== PREPARE_RUN && item.state !== RUNNING
                ).length
              }
              current={currentPage}
              onChange={(e) => {
                  this.changePage(e)
              }}
            />
          </div>
       {cnvReadShowed && (
            <CnvRead
              store={this.props.store}
              data={data}
              gene_annos={gene_annos}
              closeModal={() => this.closeModal('cnvReadShowed')}
            />
          )
        }
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/pgs/CnvReadDetail/index.js